import { render, staticRenderFns } from "./stats.component.vue?vue&type=template&id=e4e4b33a"
import script from "./stats.component.vue?vue&type=script&lang=ts"
export * from "./stats.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports